import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ChildAttendanceComponent from "../../components/applicationComponents/childAttendance/ChildAttendanceComponent";

export default function ChildAttendancePage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Child Attendance",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ChildAttendanceComponent disabled={false} />
    </>
  );
}
